import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import NavHead from "./routes-nav/NavHead";
import Routes from "./routes-nav/Routes";

import { useLocation } from "react-router-dom";
import { ErrorDisplay } from "./errors/ErrorDisplay";
import { UserProvider } from "./auth/UserContext";
import { ToastContainer } from "react-toastify";
import { AppSettingsProvider } from "./settings/AppSettingsContext";

function App() {
    const location = useLocation();

    const hideNavHead = location.pathname.startsWith("/customers") || location.pathname.startsWith("/survey/customer") || location.pathname.startsWith("/privacy-sms-policy") || location.pathname.startsWith("/terms") || location.pathname.startsWith("/tenant/login");

    return (
        <UserProvider>
            <AppSettingsProvider>
                <div
                    className={`app-shell${hideNavHead ? "" : " app-shell-with-nav"}`}
                    style={{
                        "--nav-h": "0px",
                        "--sidebar-w": hideNavHead ? "0px" : "280px",
                    }}>
                    {!hideNavHead && <NavHead />}

                    <ToastContainer
                        position="top-center"
                        autoClose={3500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                    <Routes />
                </div>
            </AppSettingsProvider>
        </UserProvider>
    );
}

export default App;
